// extracted by mini-css-extract-plugin
export var container = "TeamCarousel-module--container--52R70";
export var singleAvatarContainer = "TeamCarousel-module--singleAvatarContainer--N3TTn";
export var overlay = "TeamCarousel-module--overlay--4gihO";
export var role = "TeamCarousel-module--role--feg-G";
export var singleAvatar = "TeamCarousel-module--singleAvatar--WeU4k";
export var arrowButton = "TeamCarousel-module--arrowButton--7vcrc";
export var arrowPrev = "TeamCarousel-module--arrowPrev--MXkLK";
export var arrowNext = "TeamCarousel-module--arrowNext--svfCG";